import CityPageTemplate from "../city-template/CityPageTemplate";
import { doverConfig } from "./data";

export default function DoverPage() {
  return <CityPageTemplate config={doverConfig} />;
}